import {AbstractPlayableContent, TemporalIndicators} from "./AbstractPlayableContent";
import {Part} from "./Part";
import {defaultPiece, Piece} from "./Piece";
import {computePlayableTimeline} from "../utils/PlayableFactory";
import {getTranspositionOptionsFromJson, TranspositionOption} from "../../transposition/models/TranspositionOption";

// TODO: (back lyrics)(v2) use a real version structure based on back end one
// * add readonly on attributes
// * processedLyrics
export class Version extends AbstractPlayableContent {
  readonly piece: Piece;

  transpositions: TranspositionOption[] = []
  selectedTranspositionId: number|null = null;

  processedLyricsSimple = []
  processedLyrics = []

  difficulty: number = 3;
  singDifficulty: number = 3;

  constructor(piece: Piece, songId: number, partsTimeline: Part[], temporalIndicators: TemporalIndicators, model: any) {
    super('version', songId, piece.title + ' - ' + piece.artist, temporalIndicators, model, partsTimeline);

    this.piece = piece;
  }

  public getAnalyticsData() {
    return {
      type: 'version',
      pieceId: this.piece.id,
      pieceName: this.piece.title,
      pieceArtist: this.piece.artist,
      versionId: this.id,
      versionType: this.baseModel.version_type
    }
  }

  static createFromVersionJson(versionJson: any) {
    const temporalIndicators = new TemporalIndicators(0, versionJson.division_qty, versionJson.division_per_beat, versionJson.beat_per_measure,  versionJson.sections[0].tempo);
    const partTimeline = computePlayableTimeline(versionJson.part_timeline, 'part', versionJson.pick_up_measure * versionJson.division_per_beat * versionJson.beat_per_measure) as Part[];

    // Prepare piece
    versionJson.piece.ambitus = {high: versionJson.piece.ambitus_high, low: versionJson.piece.ambitus_low}
    versionJson.piece.challenges = versionJson.challenges;
    const version = new Version(versionJson.piece, versionJson.id, partTimeline, temporalIndicators, versionJson);
    version.difficulty = versionJson.difficulty;
    version.singDifficulty = versionJson.sing_difficulty;
    version.transpositions = getTranspositionOptionsFromJson(versionJson.transpositions, version.piece.ambitus)
    if (versionJson.piece_version_user_access) {
      version.selectedTranspositionId = versionJson.piece_version_user_access.version_transposition_id;
    }
    else {
      version.selectedTranspositionId = null;
    }

    return version;
  }
}

export const defaultVersion = new Version(defaultPiece, -1, [], new TemporalIndicators(), {version_type: 'SIMPLIFIED'})



